'use strict';

const _ = require('lodash');

function SettingsOrgSiteDetailsController (
  $http,
  $state,
  AnalyticsService,
  IdentityService,
  organization,
  OrganizationStore,
  project,
  ResourceHelper,
  sbAuth,
  SettingsActions,
  $timeout,
  SaturnGrowl,
  SiteStore,
  SiteActions,
  AppDialogsActions
) {
  const vm = this;
  const ProjectResource = ResourceHelper.getResource('Project');
  const ProjectUserResource = ResourceHelper.getResource('ProjectUser');

  // 37: AC2
  const SITE_SHARE_BLACKLIST = [37];

  if (!project || project.error) {
    projectNotFound();
    return;
  }

  vm.project = project;
  vm.projectMeta = JSON.parse(vm.project.meta);
  updateMeta();

  vm.accessLevels = [
    {
      name: 'Full Access'
    },
    {
      name: 'None'
    }
  ];
  vm.isEditingSettings = false;
  // vm.isEditingIntegrations = false;

  // this should check the logged in users projectUser membership
  vm.canEditUsers = true; // but it's always true if they can access this screen.

  vm.kSavingStatus = {
    active: 'SAVING_ACTIVE',
    success: 'SAVING_SUCCESS',
    empty: 'SAVING_EMPY'
  };

  vm.savingStatus = vm.kSavingStatus.empty;

  vm.site = project;
  vm.users = _formatUsers().filter((usr) => {
    return usr.accessIndex === 0
  });
  vm.usersObject = _mapUsers(vm.users);

  vm._tmp = {
    site: Object.create(project)
  };
  vm.siteNameInput = document.querySelector('[name="site-name"]');

  // there's a mistake in the database where 0 is treated as true and 1 as false for project.protected, so as a temporary fix, we need to negate this for the switch to display the correct value
  // TODO: fix the database
  vm.allowUserInvitations = !project.protected;

  let lodashPermission = _.chain(vm.project.settings).find({key: 'sharing'});
  vm.allowSiteSharing = !lodashPermission.has('value').value() || (lodashPermission.get('value').value() === 'enabled');

  vm.isBetaUser = IdentityService.isBetaUser();

  vm.unitOptions = [
    {
      type: 'imperial',
      descriptor: 'Imperial (ft, ft\u00B2, yd\u00B3)'
    },
    {
      type: 'metric',
      descriptor: 'Metric (m, m\u00B2, m\u00B3)'
    }
  ];

  vm.isSharingBlacklisted = SITE_SHARE_BLACKLIST.indexOf(vm.site.id) > -1;

  function getUnits () {
    var units;

    if (vm.projectMeta) {
      units = _.find(vm.unitOptions, {
        type: vm.projectMeta.units
      });
    } else {
      units = vm.unitOptions[0];
      vm.projectMeta = {
        units: units.type
      };
    }

    return units.descriptor;
  }

  vm.units = getUnits();

  vm.closeUserView = function closeUserView () {
    $state.go('settings.organization.sites');
    SettingsActions.CloseDetailView.dispatch();
  };

  function _formatUsers () {
    let users = [];

    _.forEach(organization.users, function (user) {
      _.find(project.users, function (projectUser) {
        var isProjectUser = projectUser.id === user.id;
        if (isProjectUser) {
          user.accessIndex = 0;
          user.access = vm.accessLevels[user.accessIndex];
        }
        else {
          user.accessIndex = 1;
          user.access = vm.accessLevels[user.accessIndex];
        }

        user.selectedAccessLevel = user.access;
        return isProjectUser;
      });

      users.push(user);
    });

    var formatted = _(users)
      .sortBy(function (user) {
        return user.firstName.toUpperCase();
      })
      .partition(function (user) {
        return user.access === vm.accessLevels[0];
      })
      .value();
    return formatted[0].concat(formatted[1]);
  }

  function _mapUsers (usersArray) {
    let users = {};
    usersArray.forEach((user) => {
      users[user.id] = user;
    });
    return users;
  }

  /** USER MANAGEMENT 2.0 **/
  function updateMeta() {
    ProjectResource.find(project.id).then(function(projectRes) {
      vm.project = projectRes;
      vm.projectMeta = JSON.parse(vm.project.meta);

      vm.units = getUnits();
    });
  }

  // EDIT SITE NAME
  vm.editSiteName = () => {

    vm.isEditingSettings = true;
    vm.siteNameInput.focus();
  };

  vm.cancelEditSiteName = () => {

    vm.isEditingSettings = false;
    vm._tmp.site.name = project.name;
  };

  vm.saveNewSiteName = () => {

    const currentSiteId = _.get(vm.site, ['sites', 0, 'id']);
    const siteNewData = { name: vm._tmp.site.name };

    if (!currentSiteId) {
      return;
    }

    vm.savingStatus = vm.kSavingStatus.active;

    SiteActions.UpdateSite.dispatch(currentSiteId, siteNewData);
  };

  vm.deleteSite = () => {

    const currentSite = _.get(vm.site, ['sites', 0]);

    AppDialogsActions.PromptDeleteSite.dispatch(currentSite);
  };

  // PROTECTED STATUS
  vm.updateProtectedStatus = function updateProtectedStatus () {
    vm.saveAllowProtectedStatus({
      newValue: !vm.allowUserInvitations,
      oldValue: vm.allowUserInvitations
    });
  };
  vm.saveAllowProtectedStatus = function saveAllowProtectedStatus(options) {
    vm.allowUserInvitations = options.newValue;

    vm.savingStatus = vm.kSavingStatus.active;
    // we only want to make a call to the API to update the database if the project's protected status was actually changed
    // vm.allowUserInvitations is a boolean while project.protected is a binary digit
    // therefore, we need to convert project.protected to a boolean (hence !!) for this conditional statement to work
    // this should be !== but the database bug makes it necessary to flip the check (see note in line 16)
    if (vm.allowUserInvitations === !!project.protected) {
      AnalyticsService.track('[CORE] Invitations', 'Change Project Protected Status', {
        projectName: project.name,
        projectId: project.id,
        status: vm.allowUserInvitations
      });
      ProjectResource.update(project.id, {
        protected: ~~!vm.allowUserInvitations
      }, {
        userId: IdentityService.getUser().id
      }).then(function (proj) {
        var org = OrganizationStore.get('current');
        var i = _.indexOf(org.projects, _.find(org.projects, {id: proj.id}));
        org.projects[i].protected = proj.protected;
        OrganizationStore.$set('current', org);
        OrganizationStore.$set('projects', org.projects);
        // we added a timeout because sometines the server was soo fast that the user wasn't able to tell
        // if we really did something

        $timeout(function() {
          vm.savingStatus = vm.kSavingStatus.success;
        }, 200);
      }).catch(function(err) {
        console.error(err);
        vm.allowUserInvitations = options.oldValue;
        vm.handleSavingError();
      });
    }
  };

  // SAVING
  vm.handleSavingError = function handleSavingError() {
    vm.savingStatus = vm.kSavingStatus.empty;
    SaturnGrowl.newGrowl('Your changes were unable to save, please try again.', {
      type: 'warning'
    });
  };

  // SITE SHARING
  vm.updateAllowSiteShares = function updateAllowSiteShares () {
    this.saveAllowSiteSharing({
      newValue: !vm.allowSiteSharing,
      oldValue: vm.allowSiteSharing
    });
  };

  vm.saveAllowSiteSharing = function saveAllowSiteSharing (options) {
    vm.savingStatus = vm.kSavingStatus.active;
    vm.allowSiteSharing = options.newValue;
    var siteId = _.get(vm.site, ['sites', 0, 'id']);

    SiteStore.updateSiteSettingsCanShare(siteId, options.newValue).then(() => {
      $timeout(function() {
        vm.savingStatus = vm.kSavingStatus.success;
      }, 200);
    }).catch(() => {
      console.error(err);
      vm.allowSiteSharing = options.oldValue;
      vm.handleSavingError();
    });
  };

  // UNIT TYPE
  vm.updateUnitType = function updateUnitType(newUnitType) {
    vm.saveUnitType({
      newValue: newUnitType,
      oldValue: {
        selectedUnitType: vm.selectedUnitType,
        unit: _.cloneDeep(vm.units)
      }
    });
  };
  vm.saveUnitType = function saveUnitType(options) {
    var singleSelectedUnitType =  options.newValue[0];

    // only update the projectMeta column if the units choice has changed or if the project has no projectMeta column yet
    if (!vm.projectMeta || singleSelectedUnitType && singleSelectedUnitType.type !== vm.projectMeta.units) {
      vm.selectedUnitType = options.newValue;
      vm.savingStatus = vm.kSavingStatus.active;

      var updated = {
        'units': singleSelectedUnitType.type
      };
      vm.projectMeta.units = singleSelectedUnitType.type;

      AnalyticsService.track('[CORE] Invitations', 'Change Project Units of Measurement', {
        projectName: project.name,
        projectId: project.id,
        currentUnits: vm.projectMeta.units
      });

      ProjectResource.update(project.id, {
        meta: JSON.stringify(updated)
      }).then(function() {
        // we added a timeout because sometines the server was soo fast that the user wasn't able to tell
        // if we really did something

        $timeout(function() {
          vm.savingStatus = vm.kSavingStatus.success;
        }, 200);
      }).catch(function() {
        vm.selectedUnitType = options.oldValue.selectedUnitType;
        vm.units = options.oldValue.unit;
        vm.handleSavingError();
      });
    }
  };

  vm.changeProjectUserAccess = (user) => {
    if (user.selectedAccessLevel.name === 'None') {
      return ProjectUserResource.destroy(user.id, {
        projectId: vm.project.id
      })
      .then((res) => {
        user.accessIndex = 1;
        user.access = vm.accessLevels[user.accessIndex];
        OrganizationStore.updateProjectUser(vm.project.id, user.id, 'destroy');
      })
      .catch((err) => {
        console.log(err);
      });
    }

  }

  function projectNotFound() {
    SaturnGrowl.newGrowl('We are unable to load this site. Please contact support@skycatch.com if the problem persists.', {
      type: 'alert'
    });
    $state.go('settings.organization.sites');
  }

  // vm.editIntegrations = function editIntegrations () {
  //   vm.isEditingIntegrations = !vm.isEditingIntegrations;
  // };


  // vm.saveUsers = function saveUsers () {
  //   vm.isEditingUsers = !vm.isEditingUsers;
  // };

  vm._handleSiteUpdated = () => {

    $timeout(function() {
      vm.savingStatus = vm.kSavingStatus.success;
      vm.isEditingSettings = false;
    }, 200);
  };

  vm._handleSiteUpdateError = () => {

    vm.isEditingSettings = false;
    vm.savingStatus = vm.kSavingStatus.empty;

    SaturnGrowl.newGrowl('Your changes couldn’t be saved. Please contact your organization admin or support@skycatch.com if the problem persists.', {
      id: 'site-update-error',
      type: 'alert',
      time: -1
    });
  };

  // Store Bindings
  SiteStore.on(SiteStore.Events.SiteUpdated, vm._handleSiteUpdated.bind(vm));
  SiteStore.on(SiteStore.Events.SiteUpdateError, vm._handleSiteUpdateError.bind(vm));
}

SettingsOrgSiteDetailsController.$inject = [
  '$http',
  '$state',
  'AnalyticsService',
  'IdentityService',
  'organization',
  'OrganizationStore',
  'project',
  'ResourceHelper',
  'sbAuth',
  'SettingsActions',
  '$timeout',
  'SaturnGrowl',
  'SiteStore',
  'SiteActions',
  'AppDialogsActions'
];

module.exports = SettingsOrgSiteDetailsController;



// WEBPACK FOOTER //
// ./src/app/settings/orgSites/SettingsOrgSiteDetailsController.js